import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, unref as _unref, createVNode as _createVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createTextVNode as _createTextVNode, withModifiers as _withModifiers, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"
import _imports_0 from '@/assets/images/merida-logo.png'


const _hoisted_1 = { class: "login-container" }
const _hoisted_2 = { class: "login-box" }
const _hoisted_3 = { class: "login-form" }

import { ref, reactive } from 'vue'
import { useRouter } from 'vue-router'
import { UserOutlined, LockOutlined, SafetyOutlined } from '@ant-design/icons-vue'


export default /*@__PURE__*/_defineComponent({
  __name: 'LoginPage',
  setup(__props) {

const router = useRouter()

const loginForm = reactive({
  username: '',
  password: '',
  captcha: '',
  remember: false
})

const captchaUrl = ref('-3-31280') // 这里应该是后端生成的验证码图片URL

const refreshCaptcha = () => {
  // 刷新验证码的逻辑
}

const handleLogin = async () => {
  // 实现登录逻辑
  if (loginForm.username === 'mrtAdmin' && loginForm.password === '*4b7d7fe') {
    // 保存登录状态
    localStorage.setItem('token', 'admin-token')
    // 登录成功后跳转到首页
    router.push('/')
  } else {
    // 登录失败，提示账号或密码不正确
    alert('账号或密码不正确')
  }
}


return (_ctx: any,_cache: any) => {
  const _component_a_input = _resolveComponent("a-input")!
  const _component_a_form_item = _resolveComponent("a-form-item")!
  const _component_a_input_password = _resolveComponent("a-input-password")!
  const _component_a_checkbox = _resolveComponent("a-checkbox")!
  const _component_a_button = _resolveComponent("a-button")!
  const _component_a_form = _resolveComponent("a-form")!
  const _component_a_tab_pane = _resolveComponent("a-tab-pane")!
  const _component_a_tabs = _resolveComponent("a-tabs")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _cache[8] || (_cache[8] = _createElementVNode("div", { class: "login-logo" }, [
      _createElementVNode("img", {
        src: _imports_0,
        alt: "迈睿达Logo"
      })
    ], -1)),
    _createElementVNode("div", _hoisted_2, [
      _cache[6] || (_cache[6] = _createElementVNode("div", { class: "login-header" }, [
        _createElementVNode("h1", null, "迈睿达制造供应链管理平台")
      ], -1)),
      _createElementVNode("div", _hoisted_3, [
        _createVNode(_component_a_tabs, null, {
          default: _withCtx(() => [
            _createVNode(_component_a_tab_pane, {
              key: "account",
              tab: "账号密码"
            }, {
              default: _withCtx(() => [
                _createVNode(_component_a_form, {
                  model: loginForm,
                  onSubmit: _withModifiers(handleLogin, ["prevent"])
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_a_form_item, null, {
                      default: _withCtx(() => [
                        _createVNode(_component_a_input, {
                          value: loginForm.username,
                          "onUpdate:value": _cache[0] || (_cache[0] = ($event: any) => ((loginForm.username) = $event)),
                          placeholder: "请输入账号",
                          size: "large"
                        }, {
                          prefix: _withCtx(() => [
                            _createVNode(_unref(UserOutlined))
                          ]),
                          _: 1
                        }, 8, ["value"])
                      ]),
                      _: 1
                    }),
                    _createVNode(_component_a_form_item, null, {
                      default: _withCtx(() => [
                        _createVNode(_component_a_input_password, {
                          value: loginForm.password,
                          "onUpdate:value": _cache[1] || (_cache[1] = ($event: any) => ((loginForm.password) = $event)),
                          placeholder: "请输入密码",
                          size: "large"
                        }, {
                          prefix: _withCtx(() => [
                            _createVNode(_unref(LockOutlined))
                          ]),
                          _: 1
                        }, 8, ["value"])
                      ]),
                      _: 1
                    }),
                    _createVNode(_component_a_form_item, null, {
                      default: _withCtx(() => [
                        _createVNode(_component_a_checkbox, {
                          checked: loginForm.remember,
                          "onUpdate:checked": _cache[2] || (_cache[2] = ($event: any) => ((loginForm.remember) = $event))
                        }, {
                          default: _withCtx(() => _cache[3] || (_cache[3] = [
                            _createTextVNode("记住密码")
                          ])),
                          _: 1
                        }, 8, ["checked"]),
                        _cache[4] || (_cache[4] = _createElementVNode("a", {
                          style: {"float":"right"},
                          href: "#"
                        }, "忘记密码？", -1))
                      ]),
                      _: 1
                    }),
                    _createVNode(_component_a_form_item, null, {
                      default: _withCtx(() => [
                        _createVNode(_component_a_button, {
                          type: "primary",
                          "html-type": "submit",
                          size: "large",
                          block: ""
                        }, {
                          default: _withCtx(() => _cache[5] || (_cache[5] = [
                            _createTextVNode("立即登录")
                          ])),
                          _: 1
                        })
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                }, 8, ["model"])
              ]),
              _: 1
            })
          ]),
          _: 1
        })
      ]),
      _cache[7] || (_cache[7] = _createElementVNode("div", { class: "login-footer" }, " Powered by 迈睿达 Copyright © 迈睿达供应链股份有限公司 ", -1))
    ])
  ]))
}
}

})